/** Shared Web/iOS version identity is the existing, immutable revision storageId. */
export interface HcpFile {
  id: string;
  workspaceId: string;
  postgresId: string;
  version: string;
  name: string;
  downloadUrl: string;
  uploadedAt: string;
  fileSize: number;
  pages: number;
}

export interface HcpGroup {
  id: string;
  name: string;
  sourceDeleted: boolean;
  files: HcpFile[];
}

export interface HcpViewedVersion {
  workspaceId: string;
  version: string;
}

export function hcpFile(
  id: string,
  workspaceId: string,
  data: Record<string, any>,
): HcpFile | null {
  if (
    data.deletedAt !== 0 ||
    data.publishState !== "published" ||
    !(Number(data.numNormalPages) > 0) ||
    !data.storageId ||
    !data.downloadUrl ||
    !data.postgresId
  )
    return null;
  return {
    id,
    workspaceId,
    postgresId: String(data.postgresId),
    version: data.storageId,
    name: data.fileName || data.displayTitle,
    downloadUrl: data.downloadUrl,
    uploadedAt:
      data.uploadedAt?.toDate?.().toISOString() ??
      new Date(data.uploadedAt).toISOString(),
    fileSize: Number(data.fileSize) || 0,
    pages: Number(data.numNormalPages),
  };
}

export function isUnseen(
  file: HcpFile,
  viewed: Record<string, HcpViewedVersion>,
): boolean {
  const value = viewed[file.id];
  return (
    value?.workspaceId !== file.workspaceId || value?.version !== file.version
  );
}

type WorkspaceClassification = {
  isHcpUploadWorkspace?: boolean;
  root?: { isHcpUploadWorkspace?: boolean } | null;
};
export function isOrdinaryWorkspace<T extends WorkspaceClassification>(
  workspace: T | null | undefined,
): workspace is T {
  return (
    !!workspace &&
    !workspace.isHcpUploadWorkspace &&
    !workspace.root?.isHcpUploadWorkspace
  );
}
export function isOrdinaryDocument<
  T extends { rootWorkspace?: { isHcpUploadWorkspace?: boolean } | null },
>(document: T | null | undefined): document is T {
  return !!document && !document.rootWorkspace?.isHcpUploadWorkspace;
}
